import { ComponentType, Fragment } from "react"
import { Box, SxProps } from "@mui/material"
import { ImdfFeature } from "providers/venue/types"
import { IDiningCardProps } from "./DiningCard"

interface IDiningListLayoutProps {
  pages: Array<{ data: ImdfFeature[] }>
  gridItemSx?: SxProps
  diningCardSx?: SxProps
  DiningCard?: ComponentType<IDiningCardProps>
}

export const DiningListLayout = ({
  pages,
  gridItemSx,
  diningCardSx,
  DiningCard,
}: IDiningListLayoutProps) => {
  return (
    <>
      {pages.map((page, pageNum) => (
        <Fragment key={pageNum}>
          {page.data.map((restaurant, index) => {
            const isNewShop = restaurant?.properties?.isNewShop
            const isComingSoon = restaurant?.properties?.isComingSoon
            const restaurantId = String(restaurant?.id)

            return (
              <Box
                id={restaurantId}
                data-testid={restaurantId}
                sx={gridItemSx}
                key={`dining-${restaurantId}-${index}`}
              >
                <DiningCard
                  data={restaurant}
                  sx={diningCardSx}
                  isNewShop={isNewShop}
                  isComingSoon={isComingSoon}
                />
              </Box>
            )
          })}
        </Fragment>
      ))}
    </>
  )
}
